import React from 'react';
import styles from './BackButton.module.css';

const BackButton = () => {
    const goBack = () => {
        window.history.back();
    };

    return (
        <button className={styles.backButton} onClick={goBack}>
            Volver
        </button>
    );
};

export default BackButton;